export const canReadFileContent = (file: File | Blob): Promise<boolean> =>
    new Promise((resolve) => {
        const f = new FileReader()
        f.onload = () => {
            resolve(true)
        }
        f.onerror = () => {
            resolve(false)
        }
        f.readAsBinaryString(file.slice(0, 64))
    })
